import React from 'react';
import PropTypes from 'prop-types';

const BreadcrumbsHeader = ({ data }) => {
  const { name, url } = data;
  return (
    <a href={url} className="breadcrumb-name text-truncate">
      <span className="text-truncate">{name}</span>
    </a>
  );
};

BreadcrumbsHeader.propTypes = {
  data: PropTypes.object.isRequired,
};

export default BreadcrumbsHeader;
